export default "__VITE_ASSET__C3MFz$_v__"